import { render } from "./LocationDetailsPage.vue?vue&type=template&id=3efbcae2&scoped=true"
import script from "./LocationDetailsPage.vue?vue&type=script&lang=js"
export * from "./LocationDetailsPage.vue?vue&type=script&lang=js"

import "./LocationDetailsPage.vue?vue&type=style&index=0&id=3efbcae2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3efbcae2"

export default script